import { isly } from "isly";
export var Numeric;
(function (Numeric) {
    var _a;
    Numeric.values = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    _a = isly
        .number("value", ...Numeric.values)
        .rename("isoly.Date.Month.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        return Numeric.type.get(Number.parseInt(value));
    }
    Numeric.parse = parse;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map